import { useState } from 'react';
import { GroupType } from '@/types/schemas';

/**
 * Hook for managing the active group type and filtering
 * @param defaultGroup The default group type to use
 * @returns The active group and a function to handle filtering
 */
export const useData = (defaultGroup: GroupType) => {
  const [activeGroup, setActiveGroup] = useState<GroupType>(defaultGroup);

  /**
   * Handle filtering by group type
   * @param groupType The group type to filter by
   */
  const handleFilter = (groupType: GroupType) => {
    setActiveGroup(groupType);
  };

  return {
    activeGroup,
    handleFilter
  };
};
